var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9066 15.125C9.88416 15.125 9.03174 15.9774 9.03174 16.9999V22.6246C9.03174 23.6471 9.88416 24.4995 10.9066 24.4995H11.8441C12.8666 24.4995 13.719 23.6471 13.719 22.6246V16.9999C13.719 15.9774 12.8666 15.125 11.8441 15.125H10.9066ZM10.9066 16.9999H11.8441V22.6246H10.9066V16.9999Z",
    fill: "#F0F0F0",
    stroke: "#19324C",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5314 9.5C15.5089 9.5 14.6565 10.3524 14.6565 11.3749V22.6243C14.6565 23.6468 15.5089 24.4992 16.5314 24.4992H17.4688C18.4913 24.4992 19.3437 23.6468 19.3437 22.6243V11.3749C19.3437 10.3524 18.4913 9.5 17.4688 9.5H16.5314ZM16.5314 11.3749H17.4688V22.6243H16.5314V11.3749Z",
    fill: "#F0F0F0",
    stroke: "#19324C",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1559 13.249C21.1334 13.249 20.281 14.1014 20.281 15.1239V22.6235C20.281 23.646 21.1334 24.4984 22.1559 24.4984H23.0934C24.1158 24.4984 24.9683 23.646 24.9683 22.6235V15.1239C24.9683 14.1014 24.1158 13.249 23.0934 13.249H22.1559ZM22.1559 15.1239H23.0934V22.6235H22.1559V15.1239Z",
    fill: "#F0F0F0",
    stroke: "#19324C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.2be8772dbb28f437a2f971b519e69308.svg";
export { ForwardRef as ReactComponent };